var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasPC)?_c('div',{class:_vm.diySetting?_vm.diySetting.className:'wxlite',attrs:{"id":'wechat-web-container'+_vm.params.id},on:{"click":function($event){!_vm.hasOpenLaunchFlag && _vm.OpenLite()}}},[_vm._v(_vm._s(_vm.diySetting?_vm.diySetting.buttonName:'查看详情'))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460ee1de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jump-button.vue
// module id = null
// module chunks = 